import { render, staticRenderFns } from "./SpreadForm.vue?vue&type=template&id=0d0620d8"
import script from "./SpreadForm.vue?vue&type=script&lang=js"
export * from "./SpreadForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d0620d8')) {
      api.createRecord('0d0620d8', component.options)
    } else {
      api.reload('0d0620d8', component.options)
    }
    module.hot.accept("./SpreadForm.vue?vue&type=template&id=0d0620d8", function () {
      api.rerender('0d0620d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/spread-form/SpreadForm.vue"
export default component.exports